export const IsCompleteTime =(instance) =>{
    return instance.match(/^\d{2}:\d{2}$/);
}


export const TimeStringToMinutes = (timeStr) => {
    if (!timeStr || timeStr.trim() === '') return 0; 
    
    return (Number(timeStr) === timeStr)
        ? Number(timeStr)
        : (Number(timeStr.substring(0, 2)) * 60 + Number(timeStr.substring(3)));
};

export const CalculateTotalMinutes = (startTime, endTime, breakTime) => {
    const startMinutes = TimeStringToMinutes(startTime);
    const endMinutes = TimeStringToMinutes(endTime);
    const breakMinutes = TimeStringToMinutes(breakTime);

    return endMinutes - startMinutes - breakMinutes;
};

export const DifferenceInMinutes = (first, second)=>{

    var firstInput = (Number(first)===first ) ? Number(first) : ((Number(first.substring(0,2)) * 60) + Number(first.substring(3)));
    var secondInput = (Number(second)===second ) ? Number(second) : ((Number(second.substring(0,2)) * 60) + Number(second.substring(3)));

    return  firstInput -secondInput;

}